import {connect} from "react-redux";
import AccountPage from "./AccountPage";
import * as AccountApiActions from "../actions/AccountApiActions";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

function mapStateToProps(state, ownProps) {
  return {
    accountId: ownProps.router.params.accountId
  }
}

export default connect(mapStateToProps, {...ViewActions, ...AccountApiActions})(withRouter(AccountPage));